import Box from '@mui/material/Box';
import React from 'react';

import If from './If';
import { TypeOcr, TypeOcrH4 } from './Types';

interface PriceProps {
  price: number;
}
function Price(props: PriceProps) {
  return (
    <TypeOcr fontSize='14pt' justifyContent='left' mb={3}>
      ${Math.trunc(props.price)}
    </TypeOcr>
  );
}

interface ProductNameProps {
  title: string;
}

export function PluginProductName(props: ProductNameProps) {
  return (
    <TypeOcrH4
      mt={2}
      mb={3}
      ml={2}
      sx={{
        justifyContent: 'center',

        alignText: 'start',
      }}
    >
      {props.title}
    </TypeOcrH4>
  );
}

export function PluginPrice(props: any) {
  const hasPrice =
    props.productType !== 'Sample Pack' &&
    props.productType !== 'Reason' &&
    props.productType !== 'Free Software';

  return (
    <>
      <If value={hasPrice}>
        <Box ml={2} mr={2}>
          <Price price={props.variants.nodes[props.variant].priceV2.amount} />
        </Box>
      </If>
    </>
  );
}

export default function PluginProductDesc(props: any) {
  return (
    <>
      <Box ml={2} mr={2} width='90%'>
        <div
          className='prod-html'
          dangerouslySetInnerHTML={{ __html: props.descriptionHtml }}
        />
      </Box>
    </>
  );
}
